import { Heading } from "components/designV2/heading/heading";
import { media } from "components/designV2/breakpoints";
import {
  Radius,
  Spacing,
  V2_INPUT_HEIGHT_PX,
} from "components/designV2/constants";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled, { css } from "styled-components";
import { SettingsV2PageTitle } from "../companySettingsV2.styled";

export const DetailsForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

export const DetailsPageTitle = styled(SettingsV2PageTitle)``;

type DetailsHeadingProps = {
  children: React.ReactNode;
  className?: string;
};

export const DetailsSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const DetailsSectionTitle = styled(Heading).attrs({
  color: ColorV2.Blue1,
  level: "h5",
})<DetailsHeadingProps>`
  margin: 0;
`;

export const DetailsFieldSlot = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: ${Spacing.sm}px;
  min-width: 0;
`;

type DetailsRowProps = {
  $view?: string;
};

export const DetailsRow = styled.div<DetailsRowProps>`
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: 1fr;

  ${(props) =>
    props.$view === "desktop"
      ? css`
          @media (min-width: 1000px) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        `
      : css`
          ${media.tablet} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        `}
`;

export const DetailsReadOnlyField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: ${V2_INPUT_HEIGHT_PX}px;
`;

export const DetailsReadOnlyLabel = styled(Text)``;

export const DetailsReadOnlyValue = styled(Text)`
  ${TypographyV2.b2}
  align-items: center;
  background: ${ColorV2.Blue7};
  border: 1.5px solid ${ColorV2.Blue6};
  border-radius: ${Radius.xl}px;
  display: flex;
  min-height: ${V2_INPUT_HEIGHT_PX}px;
  padding: 0 16px;
  width: 100%;
`;

export const DetailsActions = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${Spacing.sm}px;
`;
